import { Component, ReactNode } from 'react';

export class PreviewErrorBoundary extends Component<
  { onError?: (error: Error) => void; children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { onError?: (error: Error) => void; children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  override componentDidCatch(error: Error) {
    this.props.onError?.(error);
  }

  override render() {
    // don't show anything on error
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
